// CJ - Dialog to show app about information

import {
    Component,
    Inject,
    OnInit
} from "@angular/core";
import { environment } from "../../../environments/environment";

import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";

import { PlatformService } from "../../service/platform.service";

import { Device, DeviceInfo } from "@capacitor/device";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";

@Component({
    selector: "app-about-dialog",
    templateUrl: "./about.dialog.html",
    styleUrls: ["./about.dialog.css"],
    standalone: true,
    imports: [
        MatDialogModule,
        CdkDrag,
        CdkDragHandle,
        MatIconModule,
        MatButtonModule,
    ],
})
export class AboutDialogComponent implements OnInit {
  public version: string = environment.version;
  public name: string = environment.name;
  public devInfo: DeviceInfo;
  public devName = "";
  public devModel = "";
  public devMfr = "";
  public devMemUsed = 0;

  constructor(
    public platformsvc: PlatformService,
    private dialogRef: MatDialogRef<AboutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    if (data) {
      console.log("about data is set.");
    } // if (data)
  }

  async ngOnInit() {
    // If UserInfo is not defined retrieve the userInfo
    if (this.version === undefined || this.version === null) {
      console.log("AboutDialog: error no version info available");
    }
    try {
      this.devInfo = await Device.getInfo();
      this.devName = this.devInfo.name;
      this.devModel = this.devInfo.model;
      this.devMfr = this.devInfo.manufacturer;
      this.devMemUsed = this.devInfo.memUsed / 1048576;
    } catch (e) {
      console.log("Error: cant retrieve device info e=", e);
    }
  }

  close() {
    // User canceled or quit operation
    this.dialogRef.close();
  }

  async save() {
    // bundle the intent and data
  }
}
